import { createAction } from 'actions/utils'

// User interactions
export const RPWF_SET_SEARCH_VALUE = 'RPWF_SET_SEARCH_VALUE'
export const setSearchValue = createAction(RPWF_SET_SEARCH_VALUE, ['value'])

export const RPWF_START_WORKFLOW = 'RPWF_START_WORKFLOW'
export const startAddRPWorkflow = createAction(RPWF_START_WORKFLOW, [
  'serialNumber',
])

export const RPWF_SET_VIEW = 'RPWF_SET_VIEW'
export const setAddRpView = createAction(RPWF_SET_VIEW, ['view'])

export const RPWF_SET_IS_ADDING_COLLECTION = 'RPWF_SET_IS_ADDING_COLLECTION'
export const setIsAddingCollection = createAction(
  RPWF_SET_IS_ADDING_COLLECTION,
  ['isAddingCollection']
)

export const RPWF_SUBMIT_RP_SEARCH = 'RPWF_SUBMIT_RP_SEARCH'
export const submitAddRPWorkflowSearch = createAction(RPWF_SUBMIT_RP_SEARCH, [
  'searchValue',
  'serialNumber',
  'showFilteredResults',
])

export const RPWF_PAGINATE_SEARCH_RESULTS = 'RPWF_PAGINATE_SEARCH_RESULTS'
export const paginatedRPSearchResults = createAction(
  RPWF_PAGINATE_SEARCH_RESULTS,
  ['startIndex', 'search', 'showFilteredResults']
)

export const RPWF_CANCEL_WORKFLOW = 'RPWF_CANCEL_WORKFLOW'
export const cancelAddRPWorkflow = createAction(RPWF_CANCEL_WORKFLOW)

export const RPWF_STAGE_RP = 'RPWF_STAGE_RP'
export const stageRp = createAction(RPWF_STAGE_RP)

export const RPWF_REMOVE_STAGED_RP = 'RPWF_REMOVE_STAGED_RP'
export const removedStagedRP = createAction(RPWF_REMOVE_STAGED_RP, [
  'removedRP',
])

export const RPWF_CANCEL_UNAVAILABLE_PINS = 'RPWF_CANCEL_UNAVAILABLE_PINS'
export const cancelUnavilablePinsNotification = createAction(
  RPWF_CANCEL_UNAVAILABLE_PINS
)

export const RPWF_COMMIT_TO_VEHICLE = 'RPWF_COMMIT_TO_VEHICLE'
export const commitRPsToVehicle = createAction(RPWF_COMMIT_TO_VEHICLE)

export const RPWF_CANCEL_CIRCUIT_MAPPING = 'RPWF_CANCEL_CIRCUIT_MAPPING'
export const cancelCircuitMappingNotification = createAction(
  RPWF_CANCEL_CIRCUIT_MAPPING
)

export const RPWF_CONTINUE_CIRCUIT_MAPPING = 'RPWF_CONTINUE_CIRCUIT_MAPPING'
export const continueCircuitMapping = createAction(
  RPWF_CONTINUE_CIRCUIT_MAPPING
)

export const RPWF_FINISHED_WORKFLOW = 'RPWF_FINISHED_WORKFLOW'
export const finishAddRPWorkflow = createAction(RPWF_FINISHED_WORKFLOW)

export const RPWF_FINISHED_COMMIT = 'RPWF_FINISHED_COMMIT'
export const finishCommitAddRPs = createAction(RPWF_FINISHED_COMMIT)

export const RPWF_SAVE_CTP_MAPPING = 'RPWF_SAVE_CTP_MAPPING'
export const saveCTPMapping = createAction(RPWF_SAVE_CTP_MAPPING, [
  'selectedRP',
])

// Modals
export const RPWF_SHOW_SERVICE_RECORD_MODAL = 'RPWF_SHOW_SERVICE_RECORD_MODAL'

export const RPWF_SHOW_PINS_NOT_AVAILABLE_MODAL =
  'RPWF_SHOW_PINS_NOT_AVAILABLE_MODAL'
export const showPinsNotAvailableModal = createAction(
  RPWF_SHOW_PINS_NOT_AVAILABLE_MODAL,
  ['visible', 'circuitsByRPs', 'serialNumber']
)

export const RPWF_SHOW_CONFIRM_CIRCUIT_MAPPING_MODAL =
  'RPWF_SHOW_CONFIRM_CIRCUIT_MAPPING_MODAL'
export const showConfirmCircuitMappingModal = createAction(
  RPWF_SHOW_CONFIRM_CIRCUIT_MAPPING_MODAL,
  ['visible']
)

// Notifications
export const RPWF_FINISHED_COMMIT_NOTIFICATION =
  'RPWF_FINISHED_COMMIT_NOTIFICATION'
export const finishAddRPCommitNotification = createAction(
  RPWF_FINISHED_COMMIT_NOTIFICATION,
  ['code', 'errorMessage']
)

// Data
export const RPWF_SET_SELECTED_RPS = 'RPWF_SET_SELECTED_RPS'
export const setSelectedRPs = createAction(RPWF_SET_SELECTED_RPS, [
  'selectedRPs',
])

export const RPWF_POST_RP_SEARCH = 'RPWF_POST_RP_SEARCH'
export const postAddRPSearch = createAction(RPWF_POST_RP_SEARCH, [
  'search',
  'startIndex',
  'showFilteredResults',
])

export const RPWF_SET_SEARCH_RESULTS = 'RPWF_SET_SEARCH_RESULTS'
export const setAddRPSearchResults = createAction(RPWF_SET_SEARCH_RESULTS, [
  'search',
])

export const RPWF_RESET_WORKFLOW = 'RPWF_RESET_WORKFLOW'
export const resetAddRPWorkflow = createAction(RPWF_RESET_WORKFLOW)

export const RPWF_GET_REQUIRED_CIRCUITS = 'RPWF_GET_REQUIRED_CIRCUITS'
export const getRequiredCircuitsForRPs = createAction(
  RPWF_GET_REQUIRED_CIRCUITS,
  ['selectedRPs', 'serialNumber', 'isFromCollection']
)

export const RPWF_SET_STAGED_RPS = 'RPWF_SET_STAGED_RPS'
export const setStagedRPs = createAction(RPWF_SET_STAGED_RPS, ['selectedRPs'])

export const RPWF_RESET_SEARCH = 'RPWF_RESET_SEARCH'
export const resetAddRPSearch = createAction(RPWF_RESET_SEARCH)

export const RPWF_POST_COMMIT_TO_VEHICLE = 'RPWF_POST_COMMIT_TO_VEHICLE'
export const postCommitRPsToVehicle = createAction(
  RPWF_POST_COMMIT_TO_VEHICLE,
  ['notes', 'serialNumber']
)

export const RPWF_COMMIT_TO_VEHICLE_COMPLETE = 'RPWF_COMMIT_TO_VEHICLE_COMPLETE'
export const commitRPsToVehicleComplete = createAction(
  RPWF_COMMIT_TO_VEHICLE_COMPLETE,
  ['serialNumber']
)

export const RPWF_SET_IS_SEARCHING = 'RPWF_SET_IS_SEARCHING'
export const setAddRPIsSearching = createAction(RPWF_SET_IS_SEARCHING, [
  'isSearching',
])

export const RPWF_SET_IS_ADDING_RP = 'RPWF_SET_IS_ADDING_RP'
export const setAddRPIsAddingRP = createAction(RPWF_SET_IS_ADDING_RP, [
  'isAdding',
  'isFromCollection',
])

export const RPWF_COMMIT_RP_SUCCESS = 'RPWF_COMMIT_RP_SUCCESS'
export const RPWF_COMMIT_RP_FAILED = 'RPWF_COMMIT_RP_FAILED'

export const RPWF_SET_IS_STAGING_RPS = 'RPWF_SET_IS_STAGING_RPS'
export const setIsStagingRPs = createAction(RPWF_SET_IS_STAGING_RPS, [
  'isStaging',
])

export const RPWF_SET_COMMIT_NOTE = 'RPWF_SET_COMMIT_NOTE'
export const setCommitNote = createAction(RPWF_SET_COMMIT_NOTE, ['commitNote'])

export const RPWF_RESET_ADD_COLLECTION = 'RPWF_RESET_ADD_COLLECTION'
export const resetAddCollection = createAction(RPWF_RESET_ADD_COLLECTION)

export const RPWF_STAGE_COLLECTION = 'RPWF_STAGE_COLLECTION'
export const stageCollection = createAction(RPWF_STAGE_COLLECTION)

export const RPWF_SET_COLLECTIONS = 'RPWF_SET_COLLECTIONS'
export const setCollections = createAction(RPWF_SET_COLLECTIONS, ['groups'])

export const RPWF_SET_CURRENT_COLLECTION = 'RPWF_SET_CURRENT_COLLECTION'
export const setCurrentCollection = createAction(RPWF_SET_CURRENT_COLLECTION, [
  'collection',
])

export const RPWF_SET_RESOURCE_LIMITS_ERROR = 'RPWF_SET_RESOURCE_LIMITS_ERROR'
export const setResourceLimitsError = createAction(
  RPWF_SET_RESOURCE_LIMITS_ERROR,
  ['error']
)
